<template>
  <div class="commonDialogBody">
           <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >

    <el-form-item :label="formLabelAlign.obj.groupNum" >
     <el-input v-model="formLabelAlign.groupNum" size="small" placeholder="(必填)"></el-input>
    </el-form-item>
      <el-form-item :label="formLabelAlign.obj.groupName" >
     <el-input v-model="formLabelAlign.groupName" size="small"  placeholder="(必填)"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.remarks" >
     <el-input v-model="formLabelAlign.remarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {OrganizationalStructure},
  name: "BillManagementDialog",
  //  props:['formLabelAlign'],
  data() {
    return {
    options:[],
     value:"",
     isFixed:[{
         isFixedval:"0",
         isFixedlab:"否",
     },{
         isFixedval:"1",
         isFixedlab:"是",
     }],
     isFixedval:"",

       paperSpecies:[{
         paperSpeciesval:"1",
         paperSpecieslab:"发票",
     },{
         paperSpeciesval:"2",
         paperSpecieslab:"收据",
     }],
     paperSpeciesval:"",


     optionsone: [],
        valueone: '',
        dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
    };
  },
  methods: {
      ChargeisFixed(){
          // console.log(this.isFixedval)
      },
        ChargepaperSpecies(){
          // console.log(this.paperSpeciesval)
      },
      handleChange(value){
          //  console.log(value);
      },
      TenementType(value){
          // console.log(value)
          for(let val of this.options){
              if(value == val.value){
                  this.formLabelAlign.displayName = val.subjectsName
                  this.formLabelAlign.subjectsName = val.subjectsCode
              }
          }
      },
    modification(){
        if(this.title == "修改"){
          let obj = {
            "id":this.formLabelAlign.id,
              "groupNum":this.formLabelAlign.groupNum,
              "groupName":this.formLabelAlign.groupName,
              "remarks":this.formLabelAlign.remarks,
          }
        if(obj.groupNum == undefined || obj.groupNum == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.groupName == undefined || obj.groupName == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILL_MANADD,obj).then((res) => {
      let result = res.data;
               
              if (200 === result.code) {
                this.dialogVisible = false
                 this.$emit("Visible",false)
                this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }else if(this.title == "添加"){
               let obj = {
              "groupNum":this.formLabelAlign.groupNum,
              "groupName":this.formLabelAlign.groupName,
              "remarks":this.formLabelAlign.remarks,
                }
          if(obj.groupNum == undefined || obj.groupNum == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else if(obj.groupName == undefined || obj.groupName == ""){
            this.$message({
            type: "warning",
            message: "请完善必填项"
          })
          }else{
        this.$http.post(this.$requestUrl.POST_BILL_MANADD,obj).then((res) => {
      let result = res.data;
              if (200 === result.code) {
                this.dialogVisible = false
                 this.$emit("Visible",false)
                this.$message({
                    type: 'success',
                    message: '添加成功!'
                });
              } else {
                this.$message.error(result.msg)
              }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })
          }
        }


    },
    getMsgFormSon(data){
        this.optionsone = data
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
      // console.log(this.formLabelAlign)
    if(this.UserDisplay == 1){
        this.valueone =""
        this.disburseval =""
    }
              if(this.formLabelAlign.obj == undefined){
         let obj = {
            "groupNum":"票据类型代号",
            "groupName":"票据类型名称",
            "remarks":"备注信息",
          }
          // this.osData = []
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>